let favorites = localStorage.getItem('favorites') || '{}';
const favClass = '.user-favorite';
const favClassActive = 'active';

$(document).ready(function() {

    //trigger resize to disable tooltips on mobile
    $(window).trigger('resize');

    //check for all favorites and set the correct icon
    favorites = JSON.parse(favorites);
    
    //if favorites is not an empty object, highlight the favorites
    if (Object.keys(favorites).length) {
        highlightFavorites(favorites);
    }

    //listen for clicks on .user-favorite
    $(document).on('click', favClass, function(e) {
        //e.preventDefault();
        const btn = $(this);
        const id = btn.data('id');
        const type = btn.data('type').toLowerCase();
        const url = api_url + 'frontend/favorite';
        let btntext = 'Aggiungi ai preferiti';

        if (!id || !type) {
            return;
        }

        //check if the type is in the favorites object
        if (! favorites[type]) {
            favorites[type] = [];
        }

        const index = favorites[type].indexOf(id);

        if (index == -1) {
            favorites[type].push(id);
            btntext = 'Rimuovi dai preferiti';
        } else {
            favorites[type].splice(index, 1);
        }
        
        //get the happy path, set the icon
        btn.toggleClass(favClassActive);
        fixTitles(btn, btntext);

        //remove the focus from the button
        btn.trigger('blur').trigger('mouseout');
        
        if (window.authToken) {
            httpRequest(url, {type, id}, {method: 'post'}).then(function(response) {
                if (response.data.error) {
                    console.error(response.data.error);
                }
            });
            return;
        }
        
        localStorage.setItem('favorites', JSON.stringify(favorites));
    });

    $(window).on('updatefavs', function(e) {
        if (e.detail) {
            favorites = e.detail;
            highlightFavorites(favorites);
        }
    });

    function highlightFavorites(favs) {
        for (var type in favs) {
            for (var i = 0; i < favs[type].length; i++) {
                var id = favs[type][i];
                var btn = $(favClass + '[data-type="' + type + '"][data-id="' + id + '"]');
                if (btn.length) {
                    btn.addClass(favClassActive);
                }
            }
        }
        fixTitles($(favClass + '.' + favClassActive), 'Rimuovi dai preferiti');
    }

    function fixTitles(el, title) {
        el.attr('title', title)
            .tooltip('_fixTitle');
    }

    if ($('body.page-login').length) {
        //check if we are logging in and put all favorites in the post
        $('#unique-login-form').append('<input type="hidden" name="favorites" value=\'' + JSON.stringify(favorites) + '\'>');
    }
    
});

$(window).on('resize', function() {
    const userIsMobile = window.innerWidth < 992;
    if (userIsMobile) {
        $(favClass).tooltip('disable');
    } else {
        $(favClass).tooltip('enable');
    }
});